<template>
<div class="mine max-width">
	<!-- 左侧菜单 -->
	<div class='m_menu'>
		<div v-for='(item,index) in m_menu' :key='item.id' 
			 class='m_menu_line' 
			 :data-index='index' 
			 @click='func_mineMenu'>
			<!-- 图标 -->
			<div class='m_menu_li_icon'>
				<img class='m_menu_li_ic_img' :data-index='index' :src='!item.choose ? item.icon[0] : item.icon[1]' />
			</div>
			<div :class="{'theme-font-02':true, 'm_menu_li_name_choose theme-font-color':item.choose}" :data-index='index'>{{item.name}}</div>
		</div>
	</div>
	<div class='m_router'>
		<router-view/>
	</div>
</div>
</template>

<script>
/* 菜单栏图标 */
	import iconCenter from '@/assets/mine/m_center.png';
	import iconCentered from '@/assets/mine/m_center_ed.png';
	import iconOrder from '@/assets/mine/m_order.png';
	import iconOrdered from '@/assets/mine/m_order_ed.png';
	import iconFinance from '@/assets/mine/m_finance.png';
	import iconFinanceed from '@/assets/mine/m_finance_ed.png';
	import iconPersonal from '@/assets/mine/m_personal.png';
	import iconPersonaled from '@/assets/mine/m_personal_ed.png';
	import iconModify from '@/assets/mine/m_modify.png';
	import iconModifyed from '@/assets/mine/m_modify_ed.png';
	import iconAccount from '@/assets/mine/m_account.png';
	import iconAccounted from '@/assets/mine/m_account_ed.png';
export default {
	name: 'mine',
	components: {
	},
	data() {
		return {
			m_menu: [
				{id:'m01', name:'管理中心', icon:[iconCenter, iconCentered], 	 url:'manegeCenter', choose:false},
				{id:'m02', name:'订单管理', icon:[iconOrder, iconOrdered], 		 url:'orderManege', choose:true},
				{id:'m03', name:'财务明细', icon:[iconFinance, iconFinanceed], 	 url:'financeDetail', choose:false},
				{id:'m04', name:'个人资料', icon:[iconPersonal, iconPersonaled], url:'personalInfo', choose:false},
				{id:'m05', name:'修改密码', icon:[iconModify, iconModifyed], 	 url:'modifyPassword', choose:false},
				{id:'m06', name:'付款账号', icon:[iconAccount, iconAccounted], 	 url:'paymentAccount', choose:false},
				// {id:'m07', name:'价格策略设置', icon:[iconPersonal, iconPersonaled], url:'strategy', choose:false},
			]
		}
	},
	methods: {
		func_mineMenu(event) {
			const index = event.target.dataset.index;
			if (index && !this.m_menu[index]['choose']) {
				for (let i in this.m_menu) {
					if (this.m_menu[i]['choose']) {
						this.m_menu[i]['choose'] = false;
						this.m_menu[index]['choose'] = true;
						break;
					}
				}

				this.$router.push({
					name: this.m_menu[index].url
				});
			}
		}
	},
	mounted() {
		const route_name = this.$route['name'];
		console.log(route_name)
		if(!this.$parent.isorder){
			this.m_menu = [{id:'m04', name:'个人资料', icon:[iconPersonal, iconPersonaled], url:'personalInfo', choose:true}]
		}
		if (route_name !== 'manegeCenter') {
			for (let i in this.m_menu) {
				if (this.m_menu[i]['choose'] && this.m_menu[i]['url'] !== route_name) {
					this.m_menu[i]['choose'] = false;
				} else if (this.m_menu[i]['url'] === route_name) {
					this.m_menu[i]['choose'] = true;
				}
			}
		}
	}
}
</script>
<style src='@/style/mine.css'></style>
<style src='@/style/mine-h5.css'></style>



// WEBPACK FOOTER //
// src/pages/Mine.vue